import React, { FC, useContext } from "react";
import { Container } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import Navigation from "./Navigation";
import "./styles/header.scss";
import PageThemeContext from "../../Contexts/pageThemeContext";
import { THEME } from "../../theme";
import { HOMEPAGE } from "../pageRoutes";

// eslint-disable-next-line @typescript-eslint/no-require-imports
const classNames = require("classnames");

interface HeaderProps {
  hideNavLinks?: boolean;
}

const Header: FC<HeaderProps> = (props) => {
  const { hideNavLinks } = props;

  const theme = useContext(PageThemeContext);
  const pageContainerClass = classNames("pageContainer", `page-theme-${theme}`);

  const navigate = useNavigate();
  return (
    <Container className={pageContainerClass} id="headerContainer">
      <motion.div
        className="headerLogoContainer"
        onClick={() => navigate(HOMEPAGE)}
        initial={{ opacity: 0, x: -8 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.4, ease: [0.25, 0.46, 0.45, 0.94] }}
        whileHover={{ scale: 1.02 }}
        whileTap={{ scale: 0.98 }}
      >
        <img
          src={
            theme === THEME.DARK
              ? "https://kivunova.s3.us-east-1.amazonaws.com/Kivu-Nova-ligh.jpg"
              : "https://kivunova.s3.us-east-1.amazonaws.com/kivu-nova-dark.png"
          }
          alt="Logo"
          width="100%"
          height="100%"
        />
      </motion.div>
      {!hideNavLinks && <Navigation />}
    </Container>
  );
};

export default Header;
